import React from 'react';
import PropTypes from 'prop-types';

import { IntlManager } from '@atlas/core';

import useTranslate from 'common/I18n/Interpreter';

const BonusProgressBar = ({ bonus }) => {
  const { requiredWagering, wagering } = bonus;

  const t = useTranslate();
  const wagerPercent = (100 * wagering) / requiredWagering;

  return (
    <div className="progress-container">
      <div className="progress-points">
        <span className="title-small-text">{IntlManager.formatMoney(wagering)}</span>
        <span className="title-small-text">{IntlManager.formatMoney(requiredWagering)}</span>
      </div>
      <div className="progress-line">
        <div className="progress-line-element" style={{ width: `${wagerPercent}%` }} />
      </div>
      <div className="progress-info">
        <div className="product-label">
          <span className="sub-title-text">{t('Bets')}:</span>
          <span className="title-small-text">{IntlManager.formatMoney(wagering)}</span>
        </div>
        <div className="product-label">
          <span className="sub-title-text">{t('before completion')}:</span>
          <span className="title-small-text">{IntlManager.formatMoney(requiredWagering)}</span>
        </div>
      </div>
    </div>
  );
};

BonusProgressBar.propTypes = {
  bonus: PropTypes.object.isRequired,
};

export default BonusProgressBar;
